import { Directive, nextTick } from "vue";
import d from "debug";

const debug = d("cs.DataTable");

const dataTableDirective = <Directive>{
  mounted(el, binding) {
    debug("mounted", binding.value, el);
    const options = binding.value || {};
    $(el).DataTable(options);
  },
  updated(el, binding) {
    debug("updated", binding.value);
    if (binding.value) {
      $(el).DataTable().destroy(false);
      const options = binding.value || {};
      nextTick(() => {
        $(el).DataTable(options);
      });
    }
  },
  beforeUnmount(el, binding) {
    debug("beforeUnmount", binding.value);
    if (binding.value) {
      const dataTable = $(el).DataTable({ retrieve: true });
      dataTable.destroy(true);
    }
  },
};

export default dataTableDirective;
